const name = 'KIRA';
const tagline = 'Knowledge Intelligence & Recommendation Assistant';

module.exports = {
  name,
  tagline,
  title: name + ' - ' + tagline,
  description: 'Plataforma inteligente para diagnósticos precisos, trilhas de aprendizagem personalizadas e desenvolvimento de alta performance.',
  url: 'https://kira-front-end.server.gabrielpaes.com.br',
};
